import { useGeneratorContext } from '@Context/GeneratorContext';
import { CaretDown } from '@phosphor-icons/react';

import Status from './Status';
import QueueDropdown from './QueueDropdown';
import { useState } from 'react';

const Queue = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const {selectedSubtasks} = useGeneratorContext();

  return (
    <div className="relative -order-1 w-72 sm:order-1">
      <div
        role="button"
        className="flex cursor-pointer items-center justify-between rounded-md border border-gray-300 bg-white px-4 py-2"
        onClick={toggleDropdown}
      >
        <span className="flex flex-row gap-x-2 font-inter text-xs text-neutral-600 sm:text-sm">
          <label>{`Queue (${selectedSubtasks.length})`}</label>
          <label>{' - '}</label>
          <Status />
        </span>

        <CaretDown
          data-testid={'test-caret-icon'}
          weight="bold"
          className={`transform hover:text-primary-500 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </div>
      {isOpen && <QueueDropdown toggleDropdown={toggleDropdown} />}
    </div>
  );
};

export default Queue;
